import { ClientContext } from "@context/Client/ClientContext";
import { Box, Grid, Paper } from "@mui/material";
import { useClientModelVariables } from "@services/api";
import { useContext, useMemo } from "react";
import { ModelResponseCurveByChannel } from "./ModelResponseCurveByChannel";

const ModelResponseCurveChannels = () => {
  const { currentClient } = useContext(ClientContext);

  const { data: modelMediaVars } = useClientModelVariables(
    currentClient.model.id,
    "media"
  );

  const charts = useMemo(() => {
    return (modelMediaVars || [])
      .filter((media) => media.is_significant)
      .map((media) => (
        <Grid
          size={{ xs: 12, sm: 12, md: 4 }}
          sx={{ display: "flex", justifyContent: "center" }}
          key={`${currentClient.model.id}-${media.id}-response-curve-container`}
        >
          <ModelResponseCurveByChannel
            key={`${currentClient.model.id}-${media.id}-response-curve`}
            mediaId={media.id}
            mediaName={media.name}
            color={media.color}
          />
        </Grid>
      ));
  }, [modelMediaVars]);
  return (
    <Box className="w-full mt-2 pl-4 pr-4" sx={{ height: "100%" }}>
      <Paper elevation={1} sx={{ height: "100%" }}>
        <Grid container spacing={3} justifyContent="center">
          {charts}
        </Grid>
      </Paper>
    </Box>
  );
};
export default ModelResponseCurveChannels;
